<template>
    <div>
        <div class="atlhr-pf-wizard" style="max-width: 1200px; margin: 0 auto;">
        <b-alert show dismissible fade v-if='successmsg'>{{successmsg}}</b-alert>
        <b-alert show dismissible fade v-if='warningmsg' variant='warning'>{{warningmsg}}</b-alert>
        <b-alert show dismissible fade v-if='dangermsg' variant='danger'>{{dangermsg}}</b-alert>

        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-4">Receivable amount and Bank Details data confirmation</h4>  
        <div class="row">
        <div class="col-md-6">
            <table class="employee-list-table dataTable table-overflow table-sticky">
                <thead>
                    <tr class="table-head ">
                        <td  colspan="2" style="text-align: left; font-size: 11pt; width:22%;"><strong>Receivable amount and Bank Details</strong></td> 
                    </tr> 
                </thead>
                <tr class="hover-bg table-row"> 
                  <td  style="text-align: left; font-size: 11pt; width:22%;"><strong>Receivable Amount</strong></td>  <td style="text-align: right; font-size: 11pt; width:30%;" >{{formatMoney(bdata.amount)}} BDT</td> 
                </tr> 
                <tr class="hover-bg table-row"> 
                  <td  colspan="2" style="text-align: left; font-size: 11pt; width:22%;"><strong>Bank Account Details :</strong></td> 
                </tr> 
                <tr class="hover-bg table-row"> 
                  <td  style="text-align: left; font-size: 11pt; width:22%;"><strong>Beneficiary Name</strong></td>  
                  <td  style="text-align: left; font-size: 11pt; width:30%;" ><template v-if="bdata.beneficiary_name != ''">{{bdata.beneficiary_name}}</template><template v-else>N/A</template></td> 
                </tr> 
                <tr class="hover-bg table-row"> 
                  <td  style="text-align: left; font-size: 11pt; width:22%;"><strong>Account No.</strong></td>  
                  <td   style="text-align: left; font-size: 11pt; width:30%;" ><template v-if="bdata.account_no != null">{{bdata.account_no}}</template><template v-else>N/A</template></td>
                </tr> 
                <tr class="hover-bg table-row"> 
                  <td  style="text-align: left; font-size: 11pt; width:22%;"><strong>Bank Name</strong></td>
                  <td style="text-align: left; font-size: 11pt; width:30%;" ><template v-if="bdata.bank_name != null" >{{bdata.bank_name}}</template><template v-else>N/A</template></td> 
                </tr> 
                <tr class="hover-bg table-row"> 
                  <td  style="text-align: left; font-size: 11pt; width:22%;"><strong>Branch Name</strong></td>  
                  <td  style="text-align: left; font-size: 11pt; width:30%;" ><template v-if="bdata.branch_name != null">{{bdata.routing_number}}</template><template v-else>N/A</template></td> 
                </tr> 
                <tr class="hover-bg table-row"> 
                  <td  style="text-align: left; font-size: 11pt; width:22%;"><strong>Routing No.</strong></td>  
                  <td  style="text-align: left; font-size: 11pt; width:30%;" ><template v-if="bdata.routing_number != null">{{bdata.routing_number}}</template><template v-else>N/A</template></td> 
                </tr> 
            </table>

            <template v-if="bdata.updated==1" >
                <div class="accordion mt-4" role="tablist">
                    <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block v-b-toggle.accordion-1 variant="primary">
                            Proposed amount and Bank Details
                            <span class="when-opened float-right">
                                <i class="fa fa-chevron-up" aria-hidden="true">
                                </i>
                            </span>
                            <span class="when-closed float-right">
                                <i class="fa fa-chevron-down" aria-hidden="true">
                                </i>
                            </span>
                        </b-button>

                    </b-card-header>
                    <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <table class="employee-list-table dataTable table-overflow table-sticky">
                                <thead>
                                    <tr class="table-head ">
                                        <td  colspan="2" style="text-align: left; font-size: 11pt; width:22%;"><strong>Proposed amount and Bank Details</strong></td> 
                                    </tr> 
                                </thead>
                                <tr class="hover-bg table-row"> 
                                <td  style="text-align: left; font-size: 11pt; width:22%;"><strong>Receivable Amount</strong></td>  <td style="text-align: right; font-size: 11pt; width:30%;" >{{formatMoney(bdata.amount_update)}} BDT</td> 
                                </tr> 
                                <tr class="hover-bg table-row"> 
                                <td  colspan="2" style="text-align: left; font-size: 11pt; width:22%;"><strong>Bank Account Details :</strong></td> 
                                </tr> 
                                <tr class="hover-bg table-row"> 
                                <td  style="text-align: left; font-size: 11pt; width:22%;"><strong>Beneficiary Name</strong></td>  
                                <td  style="text-align: left; font-size: 11pt; width:30%;" ><template v-if="bdata.beneficiary_name_update != ''">{{bdata.beneficiary_name_update}}</template><template v-else>N/A</template></td> 
                                </tr> 
                                <tr class="hover-bg table-row"> 
                                <td  style="text-align: left; font-size: 11pt; width:22%;"><strong>Account No.</strong></td>  
                                <td   style="text-align: left; font-size: 11pt; width:30%;" ><template v-if="bdata.account_no_update != null">{{bdata.account_no_update}}</template><template v-else>N/A</template></td>
                                </tr> 
                                <tr class="hover-bg table-row"> 
                                <td  style="text-align: left; font-size: 11pt; width:22%;"><strong>Bank Name</strong></td>
                                <td style="text-align: left; font-size: 11pt; width:30%;" ><template v-if="bdata.bank_name_update != null" >{{bdata.bank_name_update}}</template><template v-else>N/A</template></td> 
                                </tr> 
                                <tr class="hover-bg table-row"> 
                                <td  style="text-align: left; font-size: 11pt; width:22%;"><strong>Branch Name</strong></td>  
                                <td  style="text-align: left; font-size: 11pt; width:30%;" ><template v-if="bdata.branch_name_update != null">{{bdata.routing_number_update}}</template><template v-else>N/A</template></td> 
                                </tr> 
                                <tr class="hover-bg table-row"> 
                                <td  style="text-align: left; font-size: 11pt; width:22%;"><strong>Routing No.</strong></td>  
                                <td  style="text-align: left; font-size: 11pt; width:30%;" ><template v-if="bdata.routing_number_update != null">{{bdata.routing_number_update}}</template><template v-else>N/A</template></td> 
                                </tr> 
                            </table>
                        </b-card-body>
                    </b-collapse>
                    </b-card>
                </div>
            </template>
            <template v-else >
                
                <div class="accordion mt-4" role="tablist">
                    <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block v-b-toggle.accordion-1 variant="primary">
                            No Proposed Details available
                            
                        </b-button>

                    </b-card-header>
                    <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                        </b-card-body>
                    </b-collapse>
                    </b-card>
                </div>
            </template> 
        </div>
     
    
        <div class="col-md-6">
            <b-card>
                <b-card-title>Confirm your information</b-card-title>
                <b-form @submit.stop.prevent="onSubmitBankInfo">                    
                    <div class="clearfix">

                        <div class="col-md-12 float-left">
                            <b-form-group id="is_appear_in_payslip-group"  label="" label-for="is_appear_in_payslip" class="is_appear_in_payslip">
                                <b-form-radio  name="is_appear_in_payslip"   v-model="employee_confirm" v-validate="{ required: true}" :state="validateState('is_appear_in_payslip')" aria-describedby="is_appear_in_payslip-feedback" data-vv-as="Your confirmation"  value=1>Yes, Available information is correct.</b-form-radio>
                                <b-form-radio name="is_appear_in_payslip"    v-model="employee_confirm" v-validate="{ required: true}" :state="validateState('is_appear_in_payslip')" aria-describedby="is_appear_in_payslip-feedback" data-vv-as="Your confirmation"  value=0>No, I want to update my information.</b-form-radio>
                                <b-form-invalid-feedback id="is_appear_in_payslip-feedback">{{ veeErrors.first('is_appear_in_payslip') }}</b-form-invalid-feedback>
                            </b-form-group>
                        </div>
                       
                        <div class="col-md-6 float-left" v-if="employee_confirm == 0 ">                    
                            <input type="hidden" v-model="bdata.id" name="id">
                           
                            <b-form-group id="amount-group" label="Receivable Amount" class="required-field" label-for="amount">
                                <b-form-input id="amount" name="amount" v-model="bdata.amount_update" v-validate="{ required: true, min: 3 }" :state="validateState('amount')" aria-describedby="amount-feedback" data-vv-as="Amount"></b-form-input>
                                <b-form-invalid-feedback id="amount-feedback">{{ veeErrors.first('amount') }}</b-form-invalid-feedback>
                            </b-form-group>


                            <b-form-group id="beneficiary_name-group" label="Beneficiary Name" class="required-field" label-for="beneficiary_name">
                                <b-form-input id="beneficiary_name" name="beneficiary_name" v-model="bdata.beneficiary_name_update" v-validate="{ required: true, min: 3 }" :state="validateState('beneficiary_name')" aria-describedby="beneficiary_name-feedback" data-vv-as="Beneficiary Name"></b-form-input>
                                <b-form-invalid-feedback id="beneficiary_name-feedback">{{ veeErrors.first('beneficiary_name') }}</b-form-invalid-feedback>
                            </b-form-group>
                            <b-form-group id="bank_name-group" label="Bank Name" class="required-field" label-for="bank_name">
                                <b-form-select id="bank_name" name="bank_name" v-model="bdata.bank_name_update" v-validate="{ required: true }" :options="bank_names" :state="validateState('bank_name')" aria-describedby="bank_name-feedback" data-vv-as="Bank Name"></b-form-select>
                                <b-form-invalid-feedback id="bank_name-feedback">{{ veeErrors.first('bank_name') }}</b-form-invalid-feedback>
                            </b-form-group>
                                            
                        </div>
                        <div class="col-md-6 float-right" v-if="employee_confirm ==  0 ">
                            <b-form-group id="account_no-group" label="Account No." class="required-field" label-for="account_no">
                                <b-form-input id="account_no" name="account_no" v-model="bdata.account_no_update" v-validate="{ required: true, min: 3, decimal:3 }" :state="validateState('account_no')" aria-describedby="account_no-feedback" data-vv-as="Account No."></b-form-input>
                                <b-form-invalid-feedback id="account_no-feedback">{{ veeErrors.first('account_no') }}</b-form-invalid-feedback>
                            </b-form-group>

                            <b-form-group id="branch_name-group" label="Branch Name" class="" label-for="branch_name">
                                <b-form-input id="branch_name" name="branch_name" v-model="bdata.branch_name_update" ></b-form-input>
                            </b-form-group>

                            <b-form-group id="routing_number-group" label="Routing No." class="" label-for="routing_number">
                                <b-form-input id="routing_number" name="routing_number" v-model="bdata. routing_no_update " v-validate="{ decimal:3 }" :state="validateState('routing_number')" aria-describedby="routing_number-feedback" data-vv-as="Routing No."></b-form-input>
                                <b-form-invalid-feedback id="routing_number-feedback">{{ veeErrors.first('routing_number') }}</b-form-invalid-feedback>
                            </b-form-group>    

                            
                        </div>
                        <div class="col-md-6 ">
                            <div class="mt-4">
                                <b-button type="submit" class="border rounded bg-light float-left py-1 px-5 mt-4 ml-2" variant="primary">Submit</b-button> 
                            </div>
                        </div>
                        
                       
                    </div>          
                </b-form>
            </b-card>
        </div>
        
      </div>   
    </div>
    </div>
</template>


<script>
    export default{
        
        mounted() {
            
        },
        props: ['pageurl', 'employee_code'],
        data(){            
            
            return {
                showoverlay_list:false,
                employee_confirm:1,
                successmsg:'',
                warningmsg:'',
                dangermsg:'', 
                bdata:[],
                bank_names: ["AB Bank Ltd","Agrani Bank","Al-Arafah Islami Bank Ltd","Bangladesh Bank","Bangladesh Commerce Bank Ltd","Bangladesh Krishi Bank","Bank Asia Ltd","BASIC Bank","BDB","BRAC Bank Ltd","Citibank, N.A.","Dhaka Bank Ltd","Dutch Bangla Bank Ltd","Eastern Bank Ltd","EXIM Bank Ltd","First Security Islami Bank Ltd","HSBC","ICB Islamic Bank","IFICBank Ltd","Islami Bank Bangladesh Ltd","Jamuna Bank Ltd","Janata Bank","Meghna Bank Ltd","Mercantile Bank Ltd","Midland Bank Ltd","Modhumoti Bank Ltd","Mutual Trust Bank Ltd","National Bank Ltd","NCC Bank Ltd","NRB Bank Ltd","NRB Commercial Bank Ltd","NRB Global Bank Ltd","One Bank Ltd","PadmaBank Ltd","Premier Bank Ltd","Prime Bank Ltd","Pubali Bank Ltd","RAKUB","Rupali Bank","SBAC Bank Ltd","Shahjalal IslamiBank Ltd","Shimanto Bank Ltd","Social Islami Bank Ltd","Sonali Bank","Southeast Bank Ltd","Standard Bank Ltd","Standard Chartered Bank Ltd","The City Bank Ltd","Trust Bank Ltd","Union Bank Ltd","United Commercial Bank Ltd","Uttara Bank Ltd"],
                
            }
        },
        methods:{
            
            editBankInfo:function(x)
            {
            if(!this.checkNet()) return false;
                let currentObj = this;
                let formData = new FormData();     
                formData.append('employee_code',  this.employee_code);          
                axios.post(this.$api_url+'/pf/bkash-get-forfeiture-data' ,formData
                ).then(function(response){
                this.bdata = response.data;

                if(this.bdata.updated==0)
                {
                    this.bdata.amount_update = this.bdata.amount;
                    this.bdata.beneficiary_name_update = this.bdata.beneficiary_name;
                    this.bdata.bank_name_update = this.bdata.bank_name;
                    this.bdata.branch_name_update = this.bdata.branch_name;
                    this.bdata.account_no_update = this.bdata.account_no;
                    this.bdata.routing_no_update = this.bdata.routing_no;
                }
                this.successmsg = null;
                }.bind(this)).catch(function (error){console.log(error)});
            },  
            
            // Start: Rejwan: 24-04-2025 2 decimal
            // formatMoney: function(amount){
            //     var money = Number(amount);

            //     if(this.$atl_company_number_format == 'no')
            //     {
            //         money = Math.round(money);
            //         money = money.toLocaleString();
            //     }
            //     else
            //     {
            //         money = money.toLocaleString();
            //         if(money=='NaN')
            //         money = amount;
            //         else{
            //         if(money.indexOf(".")<0)
            //         money = money+".00";
            //         }

            //     }
                
            //     return money;
            // },
           onSubmitBankInfo(e)
           {
            if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    this.showoverlay_list = true;
                    let currentObj = this;
                    e.preventDefault();
                    
                    const config = {
                        //headers: { 'content-type': 'multipart/form-data' }
                    }
                    let formData = new FormData();                    
                    for (let [key, value] of Object.entries(this.bdata)) 
                    {                    
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);                    
                        //console.log(`${key}: ${value}`);
                    } 
                    axios.post(this.$api_url+'/pf/bkash-update-forfeiture-data', formData, config)
                            .then(function (response) 
                            {
                                                
                                //this.getBankData();
                                this.showoverlay_list = false;
                                this.successmsg = 'Saved!';
                                this.$bvToast.toast(this.successmsg, {
                                        title: `Success`,
                                        variant: 'success',
                                        solid: true
                                    });
                               
                                this.$validator.reset();
                            
                            }.bind(this))
                            .catch(function (error) 
                            {
                                currentObj.showoverlay_list = false;
                                currentObj.serverError(error);
                            });
                });

           },
           
        },
        created: function(){
           this.editBankInfo();
        }
    }  
</script>
<style>
#is_appear_in_payslip-group .custom-control-input.is-valid ~ .custom-control-label {
	color: #000;
}
.was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {
	border-color: #000;
}
.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {
	border-color: #000;
	background-color: #000;
}
</style>